import { useState, useEffect, useRef } from "react";
import { usePubContext } from "../../../../hooks/pub-context";
import { PremiumPubInfoBoxWrapper, PremiumPubInfoTextBox } from "../../style";

const PremiumPubInfoContents = () => {
  const { data } = usePubContext();
  const infoRef = useRef<HTMLDivElement>(null);
  const [isFold, setIsFold] = useState(true);
  const [showFold, setShowFold] = useState(false);

  useEffect(() => {
    if (infoRef.current) setShowFold(infoRef.current.scrollHeight > 126);
  }, [data, infoRef]);

  return (
    <>
      <PremiumPubInfoBoxWrapper>
        <div className="title">매장 이용 안내</div>
        <PremiumPubInfoTextBox isFold={isFold}>
          <div
            ref={infoRef}
            className="content"
            dangerouslySetInnerHTML={{
              __html: (data?.informationUse || "").replace(/\n/g, "<br/>"),
            }}
          />
          {showFold && (
            <img
              src="/image-web/store/Arrow%20down.svg"
              onClick={() => setIsFold(!isFold)}
              alt="fold"
            />
          )}
        </PremiumPubInfoTextBox>
      </PremiumPubInfoBoxWrapper>
      <PremiumPubInfoBoxWrapper>
        <div className="title">업체 정보</div>
        <PremiumPubInfoTextBox>
          <div className="content">
            상호: {data?.cafeName}
            <br />
            주소: {data?.newAddress} {data?.detailAddress}
            <br />
            전화번호: {data?.vcn}
            <br />
            사업자번호: {data?.employerId || "-"}
          </div>
        </PremiumPubInfoTextBox>
      </PremiumPubInfoBoxWrapper>
    </>
  );
};

export default PremiumPubInfoContents;
